import { Navigate, RouteObject } from "react-router-dom";
import { ErrorBoundary } from "../components/ErrorBoundary";

export const useDockAutomationRoutes = (): RouteObject[] => [
  {
    path: "dock-automation",
    lazy: () => import("../pages/dockAutomation/DockAutomationLayout"),
    errorElement: <ErrorBoundary />,
    children: [
      { index: true, element: <Navigate to="outbound-loads" replace /> },
      {
        path: "outbound-loads",
        errorElement: <ErrorBoundary />,
        lazy: () =>
          import("../pages/dockAutomation/outboundLoads/OutboundLoad"),
      },
      {
        path: "incoming-breakouts",
        errorElement: <ErrorBoundary />,
        lazy: () =>
          import("../pages/dockAutomation/incomingBreakouts/IncomingBreakout"),
      },
      {
        path: "outbound-breakouts",
        errorElement: <ErrorBoundary />,
        lazy: () =>
          import("../pages/dockAutomation/outboundBreakouts/OutboundBreakout"),
      },
    ],
  },
];
